module.exports = __webpack_public_path__ + "img/city.f0c8b3ec.gif";